import axios from "axios";
import Cookies from "universal-cookie";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

const cookies = new Cookies();
const token = cookies.get("TOKEN");
// const userID = cookies.get("USER_ID");
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getSalesService = async (office: string, pageNumber: string, filters: any) => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(
    `${apiURL}/metalstrading/api/sales?office=${office}&page=${pageNumber}&buyers=${filters.buyers}&startDate=${filters.startDate}&endDate=${filters.endDate}`
  );
  return res;
};

export const getBuyersService = async () => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/buyers`);
  return res;
};

export const getMaterialService = async (materialID: any) => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/sales/materials/${materialID}`);
  return res;
};

export const getSalePDF = async (fileName: string) => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/sales/download/${fileName}`);
  return res;
};

export const getMetalsService = async () => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/metals`);
  return res;
};

export const postInvoiceService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.createdByUserID = userID;
  const res = await axios.post(`${apiURL}/metalstrading/api/invoices`, payload);
  return res;
};

export const deleteSaleService = async (saleID: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.delete(`${apiURL}/metalstrading/api/sales/${saleID}`);
  return res;
};
